export class GenerateReportError extends Error {
    
}